export default function AboutSection() {
  const scrollToContact = () => {
    const contactSection = document.getElementById('contact');
    if (contactSection) {
      contactSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="about" className="py-24 bg-gradient-to-b from-white to-[#ECFDF5]">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <div className="inline-block mb-6">
            <span className="px-5 py-2 bg-[#10B981] text-white text-sm font-medium rounded-full">
              こんなお悩み
            </span>
          </div>
          <h2 className="text-5xl font-bold text-[#065F46] mb-4" style={{ fontFamily: "'Noto Serif JP', serif" }}>
            こんなお悩み、ありませんか？
          </h2>
        </div>

        <div className="max-w-4xl mx-auto">
          <div className="bg-white rounded-3xl shadow-xl p-10 md:p-16">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-12">
              {[
                'ギックリ腰や長年の腰痛',
                '五十肩',
                '膝の痛みで歩くのが不安',
                '病院に通っても改善しない',
                'リハビリを続けても良くならない',
                '手術をすすめられて悩んでいる',
                '薬を飲み続けることに不安がある',
                'できるだけ早く良くなりたい'
              ].map((concern, index) => (
                <div key={index} className="flex items-start gap-4 p-4 bg-[#ECFDF5] rounded-xl hover:shadow-md transition-shadow">
                  <div className="w-6 h-6 flex items-center justify-center flex-shrink-0 mt-0.5">
                    <i className="ri-checkbox-circle-fill text-2xl text-[#10B981]"></i>
                  </div>
                  <p className="text-base text-[#333333] font-medium">{concern}</p>
                </div>
              ))}
            </div>

            <div className="bg-gradient-to-r from-[#10B981] to-[#059669] rounded-2xl p-10 text-center">
              <p className="text-2xl md:text-3xl font-bold text-white mb-3" style={{ lineHeight: '1.6' }}>
                その痛み
              </p>
              <p className="text-xl md:text-2xl text-white" style={{ lineHeight: '1.8' }}>
                関節センサーの乱れ、筋肉の癒着、血流障害が原因かもしれません。
              </p>
            </div>
          </div>
        </div>

        <div className="text-center mt-12">
          <button
            onClick={scrollToContact}
            className="inline-flex items-center gap-3 px-10 py-4 bg-[#10B981] text-white text-lg font-bold rounded-full hover:bg-[#059669] transition-all duration-300 shadow-xl hover:shadow-2xl cursor-pointer whitespace-nowrap"
          >
            <span>訪問整体のご相談はこちら</span>
            <i className="ri-arrow-right-line text-xl"></i>
          </button>
        </div>
      </div>
    </section>
  );
}